import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { Globals } from '../../../globals';
import { TakeawayServices } from '../services';
import { TPVServices } from '../../tpv/services';
import { TakeawayOrderDiscountRestaurantticketPage } from '../takeaway-order-discount-restaurantticket/takeaway-order-discount-restaurantticket';
import { PrintServices } from '../../services/printServices';
import { TakeawayOrderInviteDiscountElementPage } from '../takeaway-order-invite-discount-element/takeaway-order-invite-discount-element';
import { TpvLoaderPage } from '../../tpv/tpv-loader/tpv-loader';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the TpvTicketSelectedPayPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-order-pay',
  templateUrl: 'takeaway-order-pay.html',
})
export class TakeawayOrderPayPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public takeawayServices: TakeawayServices,
    public tpvServices: TPVServices,
    private printServices: PrintServices,
    public loadingCtrl: LoadingController,
    public translate: TranslateService) {
  }

  ionViewWillEnter(){
    this.tpvServices.deleteKeyboard()
  }

  calculate(total, pay) {
    var _return = pay - total;
    if (_return > 0) {
      return _return
    } else {
      return 0;
    }
  }

  back() {
    this.navCtrl.pop();
  }

  async pay(type) {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-cobrando')
    });
    loadingPopup.present();
    await this.takeawayServices.cashTicketPay(type, this.takeawayServices.selected_type);
    //opencashdrawer if can
    if (type == 'cash') {
    this.printServices.openCashDrawerByType();
    }
    this.tpvServices.keyboard_screen = '';
    loadingPopup.dismiss();
    this.navCtrl.setRoot(TpvLoaderPage);
  }

  discount() {
    this.navCtrl.push(TakeawayOrderDiscountRestaurantticketPage, {
      type: 'discount'
    });
  }

  restaurantTicket() {
    this.navCtrl.push(TakeawayOrderDiscountRestaurantticketPage, {
      type: 'restaurantticket'
    });
  }

  invite() {
    this.navCtrl.push(TakeawayOrderInviteDiscountElementPage, {
      type: 'invite'
    });
  }

  lineDiscount() {
    this.navCtrl.push(TakeawayOrderInviteDiscountElementPage, {
      type: 'linediscount'
    });
  }

  openCashDrawer() {
    this.printServices.openCashDrawerByType();
  }
}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-order-pay/takeaway-order-pay.ts